module.exports = __webpack_public_path__ + "static/media/neko-old-narrow.e314e651.png";